export default __webpack_public_path__ + "static/media/homeImg.9e54fd30.png";